import React, { useEffect, useState } from "react";
import { Typography } from "@mhome/ui";
import { TouchApp, RadioButtonUnchecked } from "@mui/icons-material";

const ButtonPress1Widget = ({ widget, onValueUpdate }) => {
  const [value, setValue] = useState(null);
  const [widgetData, setWidgetData] = useState(null);

  useEffect(() => {
    if (!widget) return;
    setWidgetData(widget);

    if (widget.items?.$w1) {
      const currentValue = widget.items.$w1.value;
      setValue(
        currentValue === "" || currentValue === null ? "standby" : currentValue
      );
    }
  }, [widget]);

  const getStatusText = () => {
    if (!value) return "standby";
    return value;
  };

  const isPressed = () => {
    return value && value !== "standby";
  };

  const getPressIcon = () => {
    return isPressed() ? (
      <TouchApp style={{ fontSize: "1.2rem" }} />
    ) : (
      <RadioButtonUnchecked style={{ fontSize: "1.2rem" }} />
    );
  };

  return (
    <div
      className="flex items-center justify-center gap-2 h-full w-full px-1 bg-transparent border rounded-2xl transition-colors duration-300"
      style={{
        borderColor: isPressed() ? "hsl(var(--primary))" : "hsl(var(--border))",
      }}
    >
      {getPressIcon()}
      <Typography className="text-sm font-medium whitespace-nowrap overflow-hidden text-ellipsis max-w-full">
        {getStatusText()}
      </Typography>
    </div>
  );
};

export default ButtonPress1Widget;
